import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import ApiService from '@/services/apiService';
import scopeBreadcrumbMixin from '@/components/core/tenant/scopeBreadCrumbMixin';
import cloneDeep from 'lodash/cloneDeep';
import flatten from 'lodash/flatten';
import get from 'lodash/get';
export default {
  name: 'CoreTenantScopesPermissionsList',
  mixins: [scopeBreadcrumbMixin],
  props: {
    userAccess: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  data: function data() {
    return {
      scopeDialog: false,
      availableRolesPerScope: {},
      scopeSelectorRoles: [],
      // updated on-the-fly, when a row is selected
      availableRoles: [],
      accessTableExpandedRows: [],
      accessTableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [15, 25, 50, {
          text: this.$i18n_t('Common.all'),
          value: -1
        }]
      },
      accessTableSearch: '',
      isLoadingScopeRoles: false,
      scopeSelectorFormValid: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'inpOutlined', 'inpFilled', 'color', 'UiTheme'])), mapGetters({
    sessionUserId: 'authentication/userId'
  })), {}, {
    accessTableRolesHeaders: function accessTableRolesHeaders() {
      return [{
        sortable: false,
        text: this.$i18n_t('Common.id'),
        value: 'id',
        width: 40
      }, {
        sortable: false,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.scope'),
        value: 'name'
      }, {
        sortable: false,
        text: this.$i18n_t('Common.action'),
        align: 'right'
      }];
    },
    selectedScopes: function selectedScopes() {
      return this.userAccess.filter(function (access) {
        return get(access, 'roles');
      }).map(function (access) {
        return _objectSpread(_objectSpread({}, get(access, 'Scope')), {}, {
          tenantId: get(access, 'tenantId')
        });
      });
    },
    buttons: function buttons() {
      return [{
        icon: 'fal fa-question-circle',
        href: "".concat(this.$store.state.app.docsBaseURL, "/accounts/"),
        target: '_blank',
        valid: true
      }, {
        title: this.$i18n_t('Common.addNew'),
        icon: 'fal fa-plus',
        action: 'addItem',
        valid: !this.loading
      }];
    }
  }),
  watch: {
    scopeDialog: function scopeDialog() {
      var _this = this;

      if (this.scopeDialog) {
        this.$nextTick(function () {
          _this.$refs['scopeSelectorForm'].validate();
        });
      }
    }
  },
  methods: {
    fetchRoles: function fetchRoles(scopeId) {
      return ApiService.fetchRoles(scopeId, this.sessionUserId);
    },
    filterRolesForScope: function filterRolesForScope(scopeId) {
      var _this2 = this;

      var lazyLoadRoles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (lazyLoadRoles && !this.availableRolesPerScope[scopeId]) {
        this.isLoadingScopeRoles = true;
        this.fetchRoles(scopeId).then(function (roles) {
          _this2.availableRolesPerScope[scopeId] = cloneDeep(roles);
          _this2.availableRoles = _this2.availableRolesPerScope[scopeId];
        }).catch(function (error) {
          console.error('Error loading scope roles', error);
        }).finally(function () {
          _this2.isLoadingScopeRoles = false;
        });
      }

      var filteredAccess = this.userAccess.filter(function (access) {
        return get(access, 'Scope.id') === scopeId;
      });
      var rolesForScope = flatten(filteredAccess.map(function (access) {
        return get(access, 'roles');
      }).filter(function (r) {
        return r;
      }));
      return rolesForScope;
    },
    scopeChosen: function scopeChosen(scopeId) {
      this.scopeSelectorRoles = this.filterRolesForScope(scopeId).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    deleteAccess: function deleteAccess(scopeId) {
      // clear all other access objects for this scope
      var newAccess = this.userAccess.filter(function (access) {
        return access.scopeId !== scopeId || !access.scopeId;
      });
      this.$emit('updatedUserAccess', newAccess);
    },
    scopeSelectorDialogSave: function scopeSelectorDialogSave() {
      (this.$refs['scopeAccessSelector'] || {}).emitRoles();
    },
    rolesChosen: function rolesChosen(roles, scopeId, tenantId) {
      // clear all other access objects for this scope
      var newAccess = this.userAccess.filter(function (access) {
        return access.scopeId !== scopeId || !access.scopeId;
      }); // NOTE: might also push an empty roles-array
      // required for matching in ApiService

      newAccess.push({
        tenantId: tenantId,
        scopeId: scopeId,
        Scope: {
          id: scopeId
        },
        roles: roles
      });
      this.$emit('updatedUserAccess', newAccess);
      this.scopeSelectorClosed();
    },
    scopeSelectorClosed: function scopeSelectorClosed() {
      this.scopeDialog = false;
    },
    clickedAccessTableRow: function clickedAccessTableRow(item) {
      if (this.accessTableExpandedRows.length === 0 || this.accessTableExpandedRows[0].id !== item.id) {
        this.availableRoles = cloneDeep(this.availableRolesPerScope[item.id]);
        this.accessTableExpandedRows = [item];
      } else {
        this.availableRoles = [];
        this.accessTableExpandedRows = [];
      }
    },
    isPrimaryScope: function isPrimaryScope(scopeId) {
      var access = this.userAccess.find(function (access) {
        return access.scopeId === scopeId;
      });
      return access ? access.primary : false;
    }
  }
};